module.exports = __webpack_public_path__ + "files/80212a7bd7eedd5a826f654d71dc29fb.png";